import { API_BASE_URL } from "../../config.tsx";

export const getNameErrors = (name: string, t: (key: string) => string) => {
  // a-zA-Z: Basic Latin
  // 0-9: Numbers
  // \-\'\s: Hyphen, apostrophe, whitespace
  // \u00C0-\u00FF: Latin-1 Supplement (Western European diacritics)
  // \u0100-\u017F: Latin Extended-A (Central European diacritics, e.g., Czech č, ř, š)
  const pattern = /^[a-zA-Z0-9\-\'\s\u00C0-\u00FF\u0100-\u017F]+$/;

  if (name.trim() === "") {
    return t("Name_is_required");
  }

  if (!pattern.test(name)) {
    return t("Invalid_characters_in_the_name");
  }

  return "";
};

export const getHeadsetNameErrors = (name: string, t: (key: string) => string) => {
  const pattern = /^[a-zA-Z0-9\-\'\s\u00C0-\u00FF\u0100-\u017F]+$/;

  if (name.trim() === "") {
    return t("Headset_name_is_required");
  }

  if (!pattern.test(name)) {
    return t("Invalid_characters_in_the_headset_name");
  }

  return "";
};

export const getHQNameErrors = (name: string, t: (key: string) => string) => {
  const pattern = /^[a-zA-Z0-9\-\'\s\u00C0-\u00FF\u0100-\u017F]+$/;

  if (name.trim() === "") {
    return t("Headquarter_name_is_required");
  }

  if (!pattern.test(name)) {
    return t("Invalid_characters_in_the_headquarter_name");
  }

  return "";
};

export const isEmailValid = (email: string) => {
  const re = new RegExp(
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.) {3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
  );
  return re.test(email.toLowerCase());
};

export const getPasswordErrors = (
  password: string,
  confirmPassword: string, t: (key: string) => string
) => {
  if (password.length < 6) {
    return t("Password_should_be_at_least_6_characters_long");
  }
  if (password.length > 4096) {
    return t("Password_should_not_exceed_4096_characters");
  }
  if (!/\d/.test(password)) {
    return t("Password_should_contain_numbers");
  }
  if (password !== confirmPassword) {
    return t("Those_passwords_didnt_match_Try_again");
  }
  return "";
};

export const getFirstNameErrors = (firstName: string, t: (key: string) => string) => {
  const pattern = /^[a-zA-Z0-9\-\'\s\u00C0-\u00FF\u0100-\u017F]+$/;

  if (firstName.trim() === "") {
    return t("First_name_is_required");
  }

  if (!pattern.test(firstName)) {
    return t("Invalid_characters_in_the_first_name");
  }

  return "";
};

export const getLastNameErrors = (lastName: string, t: (key: string) => string) => {
  const pattern = /^[a-zA-Z0-9\-\'\s\u00C0-\u00FF\u0100-\u017F]+$/;

  if (lastName.trim() === "") {
    return t("Last_name_is_required");
  }

  if (!pattern.test(lastName)) {
    return t("Invalid_characters_in_the_last_name");
  }

  return "";
};

export const correctUserRoleName = (userRole: string, t: (key: string) => string): string => {
  switch (userRole) {
    case "admin":
      return t("Global_Administrator");
    case "headquarterAdmin":
      return t("Headquarter_Administrator");
    case "headsetAdmin":
      return t("Headset_Manager");
    default:
      return userRole;
  }
};

export const formatFirestoreDate = (timestamp: any, t: (key: string) => string) => {
  if (!timestamp) return t("No_expiration_date");
  const seconds = timestamp._seconds || timestamp.seconds;
  const date = seconds ? new Date(seconds * 1000) : new Date(timestamp);
  if (isNaN(date.getTime())) return t("Invalid_Date");
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  
  return `${day}/${month}/${date.getFullYear()}`;
};

export const isFirestoreDateExpired = (timestamp: any) => {
  if (!timestamp) return false;
  const seconds = timestamp._seconds || timestamp.seconds;
  const date = seconds ? new Date(seconds * 1000) : new Date(timestamp);
  return !isNaN(date.getTime()) && date < new Date();
};
